import React from 'react';
import __ from 'lodash';

class DropdownIndikator extends React.Component{
    render(){
        return (
            this.props.indi.map((val) =>
                <option key={val.idIndikator} value={val.idIndikator}>{val.namaIndikator}</option>
            )            
        )
    }
}

export default DropdownIndikator;